import { useState, useEffect, forwardRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Typography,
  TextField,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Select,
  Stack,
  Pagination,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';

import styledComponent from "styled-components";

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Rowing } from '@material-ui/icons';

import imgNotFound from '../assets/icons/no-image.png'

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Container = styledComponent.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const Products = () => {
  const [loading, setLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  
  const [page, setPage] = useState({ value: 1 });
  const [pageInfo, setPageInfo] = useState(null);
  const [pageSize, setPageSize] = useState({ value: 24 });

  const [pageForInfo, setPageForInfo] = useState({ value: 1 });
  const [pageInfoInfo, setPageInfoInfo] = useState(null);
  const [pageInfoSize, setPageInfoSize] = useState({ value: 24 });

  const [search, setSearch] = useState(null);
  const [searchInfo, setSearchInfo] = useState(null);
  const [openInfo, setOpenInfo] = useState(false);
  const [infoStock, setInfoStock] = useState([]);

  const navigate = useNavigate();

  const handleOpenInfo = async () => {
    try {
      const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/stockinfo`, {
        params: {
            page: page.value,
            perPage: pageSize.value
        }
      });
      let number = 0;
      setInfoStock(products.data.result.data.map((v) => {
        number+=1;
        return { ...v, no: number };
      }));
      const pageInfoRes = Object.keys(products.data.result)
        .filter((key) => {
            if (key !== 'data') return true;
            return false;
        })
        .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
      setPageInfoInfo(pageInfoRes);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }

    setOpenInfo(true);
  }
  const handleCloseInfo = () => setOpenInfo(false);

  const handlePage = (event, value) => {
    setPage({ value });
    const serviceToken = window.localStorage.getItem('serviceToken');
    const getData = async () => {
        try {
          const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/katalog`, {
            params: {
                namaproduk: search,
                page: value,
                perPage: pageSize.value
            }
          });
          let number = 0;
          setProductsData(products.data.result.data.map((v) => {
            number+=1;
            return { ...v, no: number };
          }));
          const pageInfoRes = Object.keys(products.data.result)
              .filter((key) => {
                  if (key !== 'data') return true;
                  return false;
              })
              .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
          setPageInfo(pageInfoRes);
          setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };
    getData();
  };

  const handlePageForInfo = (event, value) => {
    setPageForInfo({ value });
    const serviceToken = window.localStorage.getItem('serviceToken');
    const getData = async () => {
        try {
          const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/stockinfo`, {
            params: {
                namaproduk: searchInfo,
                page: value,
                perPage: pageInfoSize.value
            }
          });
          let number = (value - 1) * (pageInfoSize.value);
          setInfoStock(products.data.result.data.map((v) => {
            number+=1;
            return { ...v, no: number };
          }));
          const pageInfoRes = Object.keys(products.data.result)
            .filter((key) => {
                if (key !== 'data') return true;
                return false;
            })
            .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
          setPageInfoInfo(pageInfoRes);
          setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };
    getData();
  };

  const handleShowAll = () => {
    const serviceToken = window.localStorage.getItem('serviceToken');
    const getData = async () => {
        try {
          setPage({value: 1});
          const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/katalog`, {
            params: {
                page: 1,
                perPage: pageSize.value
            }
          });
          let number = 0;
          setProductsData(products.data.result.data.map((v) => {
            number+=1;
            return { ...v, no: number };
          }));
          setSearch(null);
          const pageInfoRes = Object.keys(products.data.result)
              .filter((key) => {
                  if (key !== 'data') return true;
                  return false;
              })
              .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
          setPageInfo(pageInfoRes);
          setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };
    getData();
  };

  useEffect(() => {
    const getProducts = async () => {
      try {
        const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/katalog`, {
          params: {
              page: page.value,
              perPage: pageSize.value
          }
        });
        let number = 0;
        setProductsData(products.data.result.data.map((v) => {
          number+=1;
          return { ...v, no: number };
        }));
        const pageInfoRes = Object.keys(products.data.result)
          .filter((key) => {
              if (key !== 'data') return true;
              return false;
          })
          .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
        setPageInfo(pageInfoRes);
      } catch (err) {
        console.log(err);
      }
    }
    getProducts();
  }, [])

  return (
    <div style={{ minHeight: '80vh', padding: '0px 18px 50px 18px'}}>
      <Modal
        open={openInfo}
        onClose={handleCloseInfo}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Grid item xs={12} my={1}>
            <Typography variant="subtitle1">Info Stok</Typography>
          </Grid>
          <Grid item xs={12} my={1}>
            <Formik
              initialValues={{ namaproduk: null }}
              validate={async (values) => {
                const errors = {};
                if (!values.namaproduk) {
                  errors.namaproduk = 'Required';
                }
                if (values.namaproduk === '') {
                  setPageForInfo({ value: 1 });
                  setSearchInfo(null);
                  const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/stockinfo`, {
                    params: {
                        page: 1,
                        perPage: pageInfoSize.value
                    }
                  });
                  let number = 0;
                  setInfoStock(products.data.result.data.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                  }));
                  const pageInfoRes = Object.keys(products.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                  setPageInfoInfo(pageInfoRes);  
                }
                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                setPageForInfo({ value: 1 });
                try {
                  const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/stockinfo`, {
                    params: {
                        namaproduk: values.namaproduk,
                        page: 1,
                        perPage: pageInfoSize.value
                    }
                  });
                  let number = 0;
                  setInfoStock(products.data.result.data.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                  }));
                  setSearchInfo(values.namaproduk);
                  const pageInfoRes = Object.keys(products.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                  setPageInfoInfo(pageInfoRes);
                  setSubmitting(false);
                } catch (err) {
                  console.log(err);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                  <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                    <Paper
                      component="div"
                      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        required
                        name="namaproduk"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Cari data"
                        inputProps={{ 'aria-label': 'cari produk' }}
                      />
                      <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    </Paper>
                  </form>
              )}
            </Formik>
          </Grid>
          <TableContainer component={Paper} sx={{ maxHeight: '50vh' }}>
            <Table aria-label="customized table" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell>No</StyledTableCell>
                  <StyledTableCell>Stok</StyledTableCell>
                  <StyledTableCell>Produk</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {infoStock && (
                  infoStock.map((row) => (
                    <StyledTableRow key={row.idproduk}>
                      <StyledTableCell>{row.no}</StyledTableCell>
                      <StyledTableCell>{row.stock}</StyledTableCell>
                      <StyledTableCell>{row.namaproduk}</StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid item xs={12} my={1}>
            <Stack spacing={0}>
              <Pagination
                count={pageInfoInfo ? pageInfoInfo.last_page : 10}
                color="primary"
                page={pageForInfo.value}
                onChange={handlePageForInfo}
                variant="outlined"
                shape="rounded"
                size="small"
              />
            </Stack>
          </Grid>
        </Box>
      </Modal>
      <Grid container spacing={2}>
        <Grid item xs={12} my={2}>
            <Typography variant="h5" fontWeight="700">Katalog</Typography>
        </Grid>
        <Grid item xs={12} my={1}>
          <Formik
            initialValues={{ namaproduk: null }}
            validate={values => {
              const errors = {};
              if (!values.namaproduk) {
                errors.namaproduk = 'Required';
              }
              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              setPage({ value: 1 });
              try {
                const products = await axios.get(`${process.env.REACT_APP_API_URL}/api/katalog`, {
                  params: {
                      namaproduk: values.namaproduk,
                      page: 1,
                      perPage: pageSize.value
                  }
                });
                let number = 0;
                setProductsData(products.data.result.data.map((v) => {
                  number+=1;
                  return { ...v, no: number };
                }));
                setSearch(values.namaproduk);
                const pageInfoRes = Object.keys(products.data.result)
                  .filter((key) => {
                      if (key !== 'data') return true;
                      return false;
                  })
                  .reduce((cur, key) => Object.assign(cur, { [key]: products.data.result[key] }), {});
                setPageInfo(pageInfoRes);
                setLoading(false);
                setSubmitting(false);
              } catch (err) {
                console.log(err);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                  <Paper
                    component="div"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: {xs: '100%', md: '50%'}}}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      required
                      name="namaproduk"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Cari katalog"
                      inputProps={{ 'aria-label': 'cari produk' }}
                    />
                    <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                </form>
            )}
          </Formik>
        </Grid>
        <Grid item xs={12} my={1}>
          <ButtonGroup variant="contained" aria-label="outlined button group">
            <Button color="primary" onClick={() => handleShowAll()}>Tampil Semua</Button>
            <Button color="secondary" onClick={() => handleOpenInfo()}>Info Stok</Button>
          </ButtonGroup>
        </Grid>
        {productsData.map((item) => (
          <Grid item xs={6} sm={6} md={3} onClick={() => navigate('/dashboard/katalog/'+item.idkatalog)}>
            <Card sx={{ maxWidth: 345, minHeight: { xs: 353, sm: 320, md: 350 } }}>
              <CardMedia
                component="img"
                // height="240"
                sx={{height: { xs: 240, sm: 320, md: 350 }}}
                image={`https://wnj.web.id/adminwnj/foto/`+item.foto}
                alt={item.namaproduk}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src= imgNotFound;
                }}
              />
              <CardContent>
                <Typography gutterBottom variant="subtitle2" fontWeight="700" component="div">
                  {item.namaproduk}
                </Typography>
                <Typography variant="body2" fontWeight="700" color="text.secondary">
                  Rp. {item.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Stack spacing={2}>
            <Pagination
              count={pageInfo ? pageInfo.last_page : 10}
              color="primary"
              page={page.value}
              onChange={handlePage}
              variant="outlined" shape="rounded" />
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default Products;